import i18n from '@/plugins/i18n';
import { String } from 'typescript-string-operations';
import { BusinessOrderSkuAttribute } from './business-order-sku-attribute';
import { BusinessOrderSkuSerial } from './business-order-sku-serial';

export class BusinessOrderSku {
    public id: number = 0;
    public isPrincipal: boolean = false;
    public code?: string;
    public price: number | null = null;
    public discountedPrice: number | null = null;
    public attributeValues?: BusinessOrderSkuAttribute[];
    public thumbnailImageUrl?: string;
    public title?: string;
    public description?: string;
    public units: number = 0;
    public serials: BusinessOrderSkuSerial[] = [];

    public get totalPrice(): number {
        let price: number = 0;

        if (this.discountedPrice != null) {
            price = this.discountedPrice;
        } else if (this.price != null) {
            price = this.price;
        }

        return this.units * price;
    }

    public get formattedTotalPrice(): string {
        let result: string = '';

        if (this.price != null) {
            if (this.discountedPrice != null) {
                result += `<small class="old-price mr-1"><del>${i18n.n(this.units * this.price, 'currency')}</del></small>`;
            } else {
                result += `<span class="current-price">${i18n.n(this.units * this.price, 'currency')}</span>`;
            }
        }

        if (this.discountedPrice != null) {
            result += `<span class="discounted-price">${i18n.n(this.units * this.discountedPrice, 'currency')}</span>`;
        }

        return result;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                attributeValues: json.attributeValues ? json.attributeValues.map((attr: any) => new BusinessOrderSkuAttribute(attr)) : undefined,
                serials: json.serials ? json.serials.map((serial: any) => new BusinessOrderSkuSerial(serial)) : undefined,
            });
    }

    public toString(): string {
        let text = this.code ? `<em>${this.code}</em>` : '';

        if (this.attributeValues) {
            this.attributeValues.forEach((attr) => {
                text += ` | ${attr.attributeName ? attr.attributeName : ''}${attr.valueName ? (attr.attributeName ? ': ' + attr.valueName : attr.valueName) : ''}`;
            });
        }

        return String.Join(' | ', text.split(' | ').filter((s) => s));
    }
}
